import React from "react";
import { useTranslation } from "react-i18next";
import "../Accessories/Accessories.css";
import AccessoriesHero from "../../components/pages/Accessories/AccessoriesHero/AccessoriesHero";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AllProductsExplore from "../../components/pages/AllProducts/AllProductsExplore/AllProductsExplore";
import DrywallMetalFramesList from "../../components/pages/Accessories/AccessoriesMetals/DrywallMetalFramesList";
import { useProductsExploreSection } from "../../hooks/usePublicQueries";

const DrywallMetalFrames = () => {
  const { i18n } = useTranslation();
  const { data: exploreContent } = useProductsExploreSection(i18n.language);

  return (
    <div className="accessories-page">
      <div className="accessories-page-content-guide">
        <Navbar theme="dark" />
        <AccessoriesHero variant="drywall" imageSlot={1} />
        <DrywallMetalFramesList />
        <AllProductsExplore content={exploreContent} />
      </div>
      <Footer />
    </div>
  );
};

export default DrywallMetalFrames;
